export default __webpack_public_path__ + "static/media/pantry2-after1-480w.6aa6642e.png";